import { render, staticRenderFns } from "./KfActionPanel.vue?vue&type=template&id=016c41ce&scoped=true"
import script from "./KfActionPanel.vue?vue&type=script&lang=js"
export * from "./KfActionPanel.vue?vue&type=script&lang=js"
import style0 from "./KfActionPanel.vue?vue&type=style&index=0&id=016c41ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016c41ce",
  null
  
)

export default component.exports